export default __webpack_public_path__ + "static/mousePic3-46c2342d18641f9f10875e39f28e4b70.jpg";